import { render } from "./OurApp.vue?vue&type=template&id=1be96d0e&ts=true"
import script from "./OurApp.vue?vue&type=script&lang=ts"
export * from "./OurApp.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__